import { contextFactory } from '@frontend/design-system';
import { AIChatbotResponse } from '../types';

export interface ChatbotAssistantContextProps {
  messages: AIChatbotResponse[];
  isLoading: boolean;
  isSending: boolean;
  isMinimized: boolean;
  isOpen: boolean;
  position: { x: number; y: number } | null;
  addMessage: (message: AIChatbotResponse) => void;
  sendMessage: (message: string) => void;
  setIsLoading: (loading: boolean) => void;
  toggleChatbotOpen: () => void;
  toggleMinimized: () => void;
  setPosition: (position: { x: number; y: number }) => void;
}

export const [ChatbotAssistantContext, useChatbotAssistant] = contextFactory<ChatbotAssistantContextProps>();
